<template>
  <section
    :class="[
      'unum-drawer-compare',
      {
        'unum-drawer-compare--notify': chosenPlatforms.length,
        'unum-drawer-compare--active': is.compareDrawerOpen
      }
    ]"
  >
    <section class="unum-drawer-compare__head">
      <unum-button small outline color="white" @click.native="toggleCompareDrawerEvent('open')">Compare</unum-button>
    </section>
    <section class="unum-drawer-compare__body">
      <span @click="toggleCompareDrawerEvent('close')" class="menu-close">Close Drawer</span>

      <h3>Your Selected Platforms:</h3>
      <ul v-if="chosenPlatforms.length" class="unum-drawer-compare__list">
        <li v-for="platform in chosenPlatforms" :key="platform['.key']">
          {{ platform.displayName }}
          <unum-button
            small
            outline
            color="red"
            @click.native="removePlatformEvent(platform)"
          >
            Remove
          </unum-button>
        </li>
      </ul>

      <unum-button
        fullWidth
        @click.native="goToCompare"
      >
        {{
          chosenPlatforms.length > 1 ?
          'Compare These Platforms' :
          'See Details'
        }}
      </unum-button>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import UnumButton from '@/components/ui/Button'
import sessionEvent from '@/util/sessionEvent'

export default {
  name: 'UnumDrawerCompare',
  components: {
    UnumButton
  },
  methods: {
    ...mapActions('shared', [
      'toggleCompareDrawer',
      'closeCompareDrawer'
    ]),
    ...mapActions('platforms', [
      'removePlatform',
      'platformSelection'
    ]),
    goToCompare () {
      // this.closeCompareDrawer()
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_compare_drawer_details_button')
      this.$router.push({ name: 'Compare' })
    },
    removePlatformEvent (platform) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_compare_drawer_remove_platform_button', {
        platform: platform.displayName
      })
      this.removePlatform(platform)
    },
    toggleCompareDrawerEvent (action) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_compare_drawer_' + action + '_button')
      this.toggleCompareDrawer()
    }
  },
  computed: {
    ...mapState('platforms', [
      'chosenPlatforms'
    ]),
    ...mapState('shared', [
      'is'
    ])
  }
}
</script>

<style lang="scss" scoped>
.unum-drawer-compare {
  transition: transform .5s cubic-bezier(0.77,0.2,0.05,1.0);
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: translate3d(0, 250%, 0);
  width: 100%;
  z-index: 10;

  @include bp($medium) {
    width: 50%;
  }

  &--notify {
    // .drawer-compare__head {
    //   transform: translate3d(0, -100%, 0);
    // }

    // ie 11 bug work around. no calc() inside of translate3d()
    // https://stackoverflow.com/questions/21142923/ie-10-11-css-transitions-with-calc-do-not-work
    // equivalent to: `transform: translate3d(0, calc(100% - 3.5rem), 0);`
    transform: translate3d(0, 100%, 0) translate3d(0, -3.5rem, 0);
  }

  &--active {
    bottom: 0 !important;
    transform: translate3d(0, -3.5rem, 0);

    .vb-dragger {
      transform: translate3d(100%, 0, 0);
    }
  }

  &__head {
    transition: transform .5s cubic-bezier(0.77,0.2,0.05,1.0);
    background: $green;
    padding: 1rem 2rem;
    text-align: center;
    height: 3.5rem;
    width: 50%;
    margin-left: auto;

    @include bp($medium) {
      width: 100%;
    }

    // @media screen and (orientation: portrait) {
    //   width: 69.5%;
    //   margin-left: auto;
    // }

    .button {
      width: 8rem;
    }
  }

  &__body {
    height: 100%;
    background: #fff;
    box-shadow: -.063rem 0px 10px 0 rgba(0,0,0,0.25);
    position: relative;
    padding: 4rem;
    z-index: 9999;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    text-align: left;

    h3 {
      width: 100%;
      margin-top: 0;
    }

    .button {
      margin-bottom: 3.5rem;
    }
  }

  &__list,
  &__help {
    list-style: none;
    margin: 0 auto 2rem;
    padding: 0;
    text-align: left;
    width: 100%;

    li {
      width: 100%;
      & + li {
        margin-top: 1.5rem;
      }
    }
  }

  &__list {
    li {
      display: flex;
      justify-content: space-between;
      align-content: center;
      font-size: 1.5rem;
      @include bp($medium) {
        font-size: 1.25rem;
      }
    }
    .button {
      margin: 0;
    }
  }

  &__help {
    padding: 0 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/DrawerCompare.vue